<app-page-header [heading]="'Add Price'" [icon]="'fa-plus'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>

  <div class="row">
    <div class="form-group col-lg-6">
      <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="pricing_list.customer_id" class="form-control " id="name" name="name"
             type="text">
    </div>
    <div class="form-group col-lg-6">
      <label>Date</label><span class="text-danger">&nbsp;*</span>
      <input (ngModelChange)="pricing_list.date = $event" [max]="getToday()"
             [ngModel]="pricing_list.date | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">
    </div>

  </div>

  <table class="table tbl table-striped table-bordered">
    <thead>
    <tr class="text-center">
      <th width="1%">#</th>
      <th>Item</th>
      <th width="10%">MRP</th>
      <th colspan="2" width="13%">Slab A</th>
      <th colspan="2" width="13%">Slab B</th>
      <th colspan="2" width="13%">Slab C</th>

    </tr>

    <tr *ngIf="(discount_list | json) == '[]'">
      <td class="text-center" colspan="13 ">No data to list</td>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of discount_list;let i=index" style="font-size: 12px">
      <td><label>
        <input (change)="updateChecked(i,data.PURCHASE_DETAILS_ID)" [checked]="data.CHECKED == true"
               class="text-center"
               name="check"
               type="checkbox"
               value="{{data.CHECKED}}"/>
      </label>
      </td>
      <td>{{ data.TRADE_NAME }}</td>
      <td class="text-right">{{ data.MRP }}</td>
      <td class="text-center"><label>
        <input (change)="updateAChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.A_CHECK == true"
               name="a_check"
               type="checkbox"
               value="{{data.A_CHECK}}"/>
      </label></td>
      <td class="text-right">{{ data.SLAB_A_AMOUNT }}</td>
      <td class="text-center"><label>
        <input (change)="updateBChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.B_CHECK == true"
               name="b_check"
               type="checkbox"
               value="{{data.B_CHECK}}"/>
      </label></td>
      <td class="text-right">{{ data.SLAB_B_AMOUNT }}</td>
      <td class="text-center"><label>
        <input (change)="updateCChecked(i,data.PURCHASE_DETAILS_ID)"
               [checked]="data.C_CHECK == true"
               name="c_check"
               type="checkbox"
               value="{{data.C_CHECK}}"/>
      </label></td>
      <td class="text-right">{{ data.SLAB_C_AMOUNT }}</td>
    </tr>
    </tbody>
  </table>

  <div class="clearfix"></div>
  <div class="row container">
    <div class="col-lg-7 pull-right">
      <button (click)="saveAddPrice();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
              type="button">&nbsp;Save&nbsp;
      </button>&nbsp;&nbsp;&nbsp;
    </div>
  </div>


  <div id="printOrder" style="display: none">
    <div>
      <header>
        <div class="clearfix"></div>

      </header>
      <div class="header-space">&nbsp;</div>
      <div class="footer-space">&nbsp;</div>
      <div class="header col-md-12">
        <div class=" col-md-12">
          <div class="col-md-4 pull-left">
            <ng-container *ngIf="institution.INSTITUTION_LOGO">
              <img alt="" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" width="150">
            </ng-container>
          </div>
          <div class="col-md-8 pull-right text-right  ">
            <ng-container *ngIf="institution">
              <h5 class="name"><b>{{ institution.INSTITUTION_NAME }}</b></h5>
              <div style="line-height: 0.85em;"><label
                style="font-size: 16px;">{{ institution.INSTITUTION_ADDRESS }}</label></div>
              <div style="line-height: 0.85em;"><label style="font-size: 16px;">{{ institution.INSTITUTION_CITY }},&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }}</label>
              </div>
              <div style="line-height: 0.85em;"><label style="font-size: 16px;">Ph
                :&nbsp;{{ institution.INSTITUTION_PHONE_NO }}</label></div>
              <div style="line-height: 0.85em;"><label style="font-size: 16px;">Email
                :&nbsp;{{ institution.INSTITUTION_EMAIL }}</label></div>
              <div style="line-height: 0.85em;"><label style="font-size: 16px;">VAT
                IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }},&nbsp;State Code&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.TIN_NUMBER }}</label>
              </div>

            </ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="institution" class="footer col-lg-12 text-center" style="font-size: 12px;">
        <hr>
        {{ institution.INSTITUTION_NAME }}<br>{{ institution.INSTITUTION_ADDRESS }},{{ institution.INSTITUTION_CITY }}
        ,{{ institution.INSTITUTION_COUNTRY_NAME }}<br>www.wiktait.com
      </div>

      <div>&nbsp;</div>
      <h5 class="text-center"><span>PRICING LIST</span></h5>
      <br>
      <div>&nbsp;</div>
      <main>
        <div class="row col-lg-12" style="font-size: 16px;">
          <div class="col-6 pull-left " style="font-size: 16px;">
            <div class="row">
              <div class="col-3">
                <label style="font-size: 16px;"> Customer</label>
              </div>
              <div class="col-9">
                <label style="font-size: 16px;"> :</label>
              </div>
            </div>
          </div>
          <div class="col-6 pull-right text-right">
            <div><label style="font-size: 16px;">Date&nbsp;&nbsp; :&nbsp; &nbsp;&nbsp;</label></div>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <table class=" container col-lg-12 printtable" style="font-size: 16px;">
            <thead>
            <tr style="font-size: 16px;">
              <th width="5%">Sl</th>
              <th>Item</th>
              <th width="10%">Price</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let lists of print_data;let i=index" style="font-size: 16px;">
              <td class="text-center">{{ 1 + i }}</td>
              <td> {{ lists.TRADE_NAME }}</td>
              <td class="text-center">{{ lists.QUANTITY }}</td>
              <td class="text-center">{{ lists.SHORT_FORM }}</td>
              <td class="text-right">{{ lists.UNIT_PRICE }}</td>
              <td class="text-right">{{ lists.TOTAL_AMOUNT }}</td>
            </tr>
            </tbody>
          </table>

        </div>

      </main>
      <div class="clearfix"></div>

    </div>
  </div>
</div>
